/* React hooks */
import {useEffect, useState} from "react";
/* Components */
import FormInputs from "../../FormInputs";
import {useLocation, useParams} from "react-router-dom";
import useData from "../../../hooks/useData";
import {getLegalFormList} from "../../../api/admin/legalFormListReq";
import useAuth from "../../../hooks/useAuth";
import {getActivityList} from "../../../api/admin/activityReq";
import {getAgencyMainInfos, getAgencyProInfos, updateAgencyInfos} from "../../../api/admin/agencyReq";
import FormButtons from "../../../components/common/FormButtons";
import DateInput from "../../../components/common/input-layout/DateInput";
import jwt_decode from "jwt-decode";
import {
    checkRequiredFields,
    getDeep,
    getErrorListFromValidation,
    patternListChoices,
    removeErrorList,
    validateFormInput
} from "../../../helper/tools";
import Icon from "../../../components/common/Icon";


export default function FormAgencyGeneral({ legend, setShowModal, apiAgencyMainInfos }) {
    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = jwt_decode(token);
    const agencyId = decodedToken?.agency;
    const { id } = useParams();
    const { legalFormList, setLegalFormList} = useData();
    const { activityList, setActivityList } = useData();
    const [ agencyActivities, setAgencyActivities ] = useState();
    const [ agencyMainInfos, setAgencyMainInfos ] = useState();
    const [ agencyProInfos, setAgencyProInfos ] = useState();
    const [values, setValues] = useState();
    const { pathname } = useLocation();

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        if (e.target.type === "checkbox") {
            setValues({...values, [e.target.name] : e.target.checked})
        }
        validateFormInput(e);
    };

    const apiLegalFormList = async () => {
        const response = await getLegalFormList(token);
        setLegalFormList(response);
    };

    const apiActivityList = async () => {
        const response = await getActivityList(token);
        setActivityList(response);
    }

    const apiMainInfos = async () => {
        const response = await getAgencyMainInfos(token, id);
        setAgencyMainInfos(response);
    }

    const apiProInfos = async () => {
        const response = await getAgencyProInfos(token, agencyId);
        setAgencyProInfos(response);
    }

    useEffect(() => {
        if (pathname?.includes("admin")) {
            setValues(agencyMainInfos)
        } else {
            setValues(agencyProInfos)
        }
    }, [ agencyMainInfos, agencyProInfos, pathname ]);

    useEffect(() => {
        apiMainInfos();
        apiProInfos();
    },[ id ]);

    useEffect(() => {
        setAgencyActivities(values?.activity)
    }, [ values ]);

    useEffect(() => {
        apiLegalFormList();
        apiActivityList();
    }, [ token ]);

    const legalFormOptionList = legalFormList?.map(legalForm => (
        { [legalForm?.id] : [legalForm?.name] }
    ));

    const inputs = [
        {
            id : 1,
            type : "text",
            name : "name",
            placeholder : "Nom de l'agence",
            label : "Nom",
            pattern : patternListChoices?.name,
            required : true,
        },
        {
            id : 2,
            name : "headquarters",
            type : "checkbox",
            label : "Siège social",
        },
        {
            id : 3,
            name : "isEnsemble",
            type : "checkbox",
            label : "Ensemble",
        },
        { id : 12,
            type : "text",
            name : "orias",
            placeholder : "Numéro ORIAS",
            label : "Numéro ORIAS",
            pattern: patternListChoices?.alphaNum
        },
        {
            id : 13,
            type : "text",
            name : "headquartersAddress",
            placeholder : "Adresse du siège social",
            label : "Adresse du siège social",
            pattern: patternListChoices?.address
        },
        {
            id : 14,
            type : "text",
            name : "headquartersPostalCode",
            placeholder : "Code postal du siège social",
            label : "Code postal du siège social",
            pattern: patternListChoices?.postalCode
        },
        {
            id : 15,
            type : "text",
            name : "headquartersCity",
            placeholder : "Ville du siège social",
            label : "Ville du siège social",
            pattern: patternListChoices?.city

        },
        {
            id : 4,
            name : "authorizationCode",
            type : "text",
            placeholder : "Code d'habilitation",
            label : "Code d'habilitation",
            pattern: patternListChoices?.alphaNum
        },
        {
            id : 6,
            name : "siret",
            type : "text",
            placeholder : "Siret",
            label : "Siret",
            pattern: patternListChoices?.siret

        },
        {
            id : 7,
            name : "tvaNumber",
            type : "text",
            placeholder : "TVA intracommunautaire",
            label : "TVA intracommunautaire",
            pattern: patternListChoices?.tvaIntra
        },
        {
            id : 8,
            name : "capital",
            type : "text",
            placeholder : "",
            label : "Capital",
            pattern: patternListChoices?.num
        },
        {
            id : 9,
            name : "workforce",
            type : "text",
            placeholder : "Effectif",
            label : "Effectif",
            pattern: patternListChoices?.num
        },
        {
            id : 10,
            name : "hours",
            type : "text",
            placeholder : "Horaires",
            label : "Horaires",
        },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!checkRequiredFields()) {
            return;
        }
        let typeOfLegalForm = typeof (values?.legalForm) === "object" ? values?.legalForm?.id : values?.legalForm;
        let typeOfEnsemble = typeof (values?.ensemble) === "object" ? values?.ensemble?.id : values?.ensemble;
        let agency;
        if (pathname?.includes("admin")) { agency = id } else { agency = agencyId }
        let body = {
            agencyId: agency,
            name: values?.name || "",
            headquarters: values?.headquarters || false,
            isEnsemble: values?.isEnsemble || false,
            orias: values?.orias || "",
            ensembleId: typeOfEnsemble || "",
            legalForm: typeOfLegalForm || "",
            authorizationCode: values?.authorizationCode || "",
            registrationDate: values?.registrationDate || "",
            siret: values?.siret || "",
            tvaNumber: values?.tvaNumber || "",
            capital: parseInt(values?.capital) || null,
            workforce: parseInt(values?.workforce) || null,
            hours: values?.hours || "",
            activity: agencyActivities?.map(activity => activity?.id) || [],
        }
        await updateAgencyInfos(token, body)
            .then((response) => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    setShowModal(false);
                    apiAgencyMainInfos();
                } else {
                    getErrorListFromValidation(response?.response?.data?.error);
                }
            })
    }

    const handleAdd = (id, name) => {
        if (!agencyActivities?.find(activity => activity?.id === id)) {
            setAgencyActivities([...agencyActivities, {id, name}])
        }
    }

    const handleDelete = (id) => {
        setAgencyActivities(agencyActivities?.filter(activity => activity?.id !== id))
    }

    const handleRemoveModal = () => {
        setShowModal(false);
    };

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <fieldset>
                {(legend !== "no-legend") && <Icon source="fa fa-home" span={ legend }/>}
                    {inputs.map(input =>(
                        <FormInputs
                            type={ input.type }
                            name={ input.name }
                            id={ input.id }
                            label={input.label}
                            placeholder={ input.placeholder }
                            value={ getDeep(values, input.path || input.name) }
                            onChange={ onChange }
                            required={ input.required }
                            options={ input.options }
                            selected={ input.selected }
                            multiple={ input.multiple }
                            key={ input.id+input.name }
                            pattern={ input.pattern }
                            defaultOpt={ input.defaultOpt }
                            defaultOptName={ input.defaultOptName }
                        />
                    ))}
                <div className="form-input">
                    <label htmlFor="legalForm">Forme juridique</label>
                    <select name="legalForm" onChange={onChange} value={values?.legalForm?.id}>
                        <option name="legalForm" selected="selected" value="">Sélectionner une forme juridique</option>
                        {legalFormOptionList?.map((legalForm, index) => (
                            <option key={index} name="legalForm" value={Object.keys(legalForm)}>{Object.values(legalForm)}</option>
                        ))}
                    </select>
                </div>
                <div className="form-input">
                    <label htmlFor="registrationDate">Date d'immatriculation</label>
                    <DateInput name="registrationDate" max="9999-12-31" onChange={onChange} value={values?.realRegistrationDate}/>
                </div>
                <div className="form-activities">
                    <div className="column">
                        <label>Ajouter une activité</label>
                        <div className="flex">
                            <div className="agency-activities">
                                <div className="flex">
                                    {activityList?.filter(activity => activity?.activityEnabled)?.map(activity => (
                                        <span key={activity?.id}
                                          onClick={() => handleAdd(activity?.id, activity?.name)}>
                                            <i className="fa fa-plus"></i>
                                            {activity?.name}</span>
                                    ))}
                                </div>

                            </div>
                            <div className="agency-activities-selected">
                                {agencyActivities?.map(activity => (
                                    <span key={activity?.id} id={activity?.id}>{activity?.name}<i
                                        onClick={() => handleDelete(activity?.id)} className="fa fa-trash"></i></span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="errors"></div>
            </fieldset>
            <FormButtons handleRemoveModal={handleRemoveModal}/>
        </form>
    )
}
